<template>
  <div class="loading-overlay-container">
    <!-- Opaque background -->
    <div class="loading-overlay-modal-background" />

    <!-- Inner body -->
    <div class="loading-inner-container">
      <img
        src="/assets/loading-animation.gif"
        alt="loading"
      >
      <h2 class="loading-title">
        {{ title }}
      </h2>
      <label class="subtitle">{{ subTitle }}</label>
    </div>
  </div>
</template>


<script>
export default {
  name: "LoadingOverlayComponent",
  components: {},
  props: ["title", "subTitle"],
  data() {
    return {};
  },

  computed: {},

  mounted() {},
};
</script>

<style scoped>
  .loading-title {
    text-align: center;
  }
</style>